import styled from 'styled-components';
import { ASSETS } from '../../../utils/config';
import { HEADER_HEIGHT } from '../../WheelGallery/Header/styles';
// nem3-sweep-responsive-notifications-chat-390 (ISP-9999): `width: 30vw` alone
// is fine on desktop (e.g. ~576px at a 1920px viewport) but this is the
// legacy dropdown that actually renders on web-dev today (NOTIF_CENTER_ENABLED
// is off there, see GalleryHeader.jsx) — on a 390px mobile viewport 30vw is
// only ~117px, way too narrow for the "Mark all as read" / "View All" buttons
// row (ButtonsContainer, 20px padding + 10px gap) or notification row text to
// fit without wrapping/clipping. The flag-gated replacement (NotificationCenter.
// styled.js's `Panel`) already solved this with a `min-width`/`max-width`
// clamp (see NotificationCenter.responsivePanelWidth.test.jsx) — this second,
// still-live component never got the same treatment. `min-width: 280px` gives
// mobile a usable panel; `max-width: calc(100vw - 40px)` keeps it (and its
// `right: 20px` anchor) fully on-screen even below 280px viewports. Neither
// bound engages at typical desktop widths, so desktop sizing is unchanged.
export const Dropdown = styled.div`
  position: absolute;
  width: 30vw;
  min-width: 280px;
  max-width: calc(100vw - 40px);
  /* header-tighter-messenger-parity-0916: open right under the header (one token), not a 10vh guess. */
  top: ${HEADER_HEIGHT}px;
  right: 20px;
  box-shadow: 0px 4px 7px 0px #00000014;
  border-radius: 8px;
  z-index: 9999;
  border: 1px solid white;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  background-color: white;
`;

export const NotificationWrapper = styled.div`
  height: 50vh;
  overflow-y: auto;
  width: 100%;

  /* Hide scrollbar for modern browsers */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px;
  gap: 10px; /* Adds spacing between buttons */
  align-items: center;

  button {
    width: auto; /* Ensure width adapts to text content */
    padding-left: 12px;
    padding-right: 12px;
  }
`;

// nem3-sweep-responsive-notifications-chat-390 (ISP-9999): width used to be
// its own hardcoded 30vw -- a second copy of Dropdown's width that had to be
// kept in lockstep by hand and never picked up Dropdown's min/max-width
// mobile clamp above. 100% always matches Dropdown's actual (now-clamped)
// width instead.
export const TopBar = styled.div`
  display: flex;
  justify-content: space-between; /* Space between left and right parts */
  padding: 16px;
  background-color: white;
  width: 100%;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  position: relative;
`;
